import { useEffect, useState } from "react";
import { storedLocale } from "../../../../Authentication/util";
import { useAppSelector } from "../../../../../store";
import { useGetHatGarTrackingQuery } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI";
import type { HatGarTrackingResponse } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI.types";
import { TrendEnum } from "../../../../../common/leaf/LeafTrendIndicator/LeafTrendIndicator";
import { QUALIFICATION_STATUS } from "../../../../../common/enums/incentive-enums";

const hatGarTrackingInitial: HatGarTrackingResponse = {
  showHat: false,
  showGar: false,
  showInMarketPin: false,
  hatTracking: {
    routeId: "",
    inMarketLegs: { value: 0, trend: { difference: 0, trend: TrendEnum.EQUAL } },
    foundersLegs: { value: 0, trend: { difference: 0, trend: TrendEnum.EQUAL } },
    totalLegs: { value: 0, trend: { difference: 0, trend: TrendEnum.EQUAL } },
    inMarketPinTrackingLevel: { rank: 0, label: "" },
    inMarketPinLevelPY: { rank: 0, label: "" },
    foundersPlatinumStatus: { show: false, modal: null },
  },
  garTracking: {
    routeId: "",
    foundersPlatinumLegs: { count: 0, met: false },
    totalLegsCounting: { value: 0, trend: { difference: 0, trend: TrendEnum.EQUAL } },
    qualCredits: { value: 0, trend: { difference: 0, trend: TrendEnum.EQUAL } },
    qualCreditMaxPerLeg: 0,
    qualCreditsNotCounting: { count: 0, met: false },
    founderDiamondStatus: QUALIFICATION_STATUS.NOT_TRACKING,
    globalAwardTrackingLevel: { rank: 0, label: "" },
    globalAwardLevelPY: { rank: 0, label: "" },
    highestAwardLevel: { rank: 0, label: "" },
  },
  garMatrixRows: [],
  callResults: [],
};

export const FetchHatGarData = (period: string) => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetHatGarTrackingQuery({
    aff: user.aff,
    abo: user.abo,
    period,
    isoCountryCode: user.isoCountryCode,
    locale: storedLocale(),
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [hatGarData, setHatGarData] = useState<HatGarTrackingResponse>(hatGarTrackingInitial);

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setHatGarData(payloadData);
    }
  }, [isFetching, period, isError, payloadData]);

  return { isLoading, hatGarData, errorStatus, refetch };
};
